import React from 'react'
import styled from 'styled-components'
import {TextField, FormControl} from '@material-ui/core'

const Label = styled.div`
	font-weight: 700;
	font-size: 13.5px;
	line-height: 1;
	margin-bottom: 5px;
`

const Container = styled(FormControl)`
	&& {
		margin-bottom: 30px;
	}
`

const Text = ({label, defaultValue, fieldId, readonly, multiline, invalid, handleChange}) => {
	const onChange = (e) => {
		handleChange(e.target.name, e.target.value)
	}

	return (
		<Container data-id={invalid ? fieldId : null}>
			<Label dangerouslySetInnerHTML={{__html: label}} />
			<TextField
				defaultValue={defaultValue}
				name={'c' + fieldId}
				onChange={onChange}
				InputProps={{
					readOnly: readonly
				}}
				multiline={multiline}
                rows={multiline ? 5 : 1}
				error={invalid}
			/>
		</Container>
	)
}

export default React.memo(Text)